export const ASTERISK = 'ASTERISK'
export const ONE_NUMBER = 'ONE_NUMBER'
export const SEVERAL_NUMBERS = 'SEVERAL_NUMBERS'
